<head>
    <link href='https://api.mapbox.com/mapbox-gl-js/v1.10.1/mapbox-gl.css' rel='stylesheet' />
    <link href='https://api.tiles.mapbox.com/mapbox-gl-js/v2.9.2/mapbox-gl.css' rel='stylesheet' />
</head>

<template>
    <div id="map" class="basemap">
        
        
        
    </div>
    <!-- <MglMap id="basemap" :accessToken="accessToken" :mapStyle="mapStyle"/> -->
</template>

<script>
// import Mapbox from "mapbox-gl";
// import { MglMap } from "vue-mapbox";
//     //import { map } from "@firebase/util";
import mapboxgl from "mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css';

    export default {


        name: "BaseMap",
        data(){
            return {
                accessToken: "pk.eyJ1IjoiamFzb25waXR0cyIsImEiOiJjbDB3eXVobm8waXZwM3Buc2pwcnBiNGRwIn0.EBfoU8xAT_uC4MEbuzG-2g",
                boundries: null,
                testLocations: [
                    [-112.210458, 41.081484]
                ],
                notInAreaErrorMessage: false
            };
        },
        mounted(){
            mapboxgl.accessToken = this.accessToken;

            //const marker1 = new mapboxgl.LngLat(-112.181420, 41.089326);

            //test bounds
            const sw = new mapboxgl.LngLat(-112.273911, 40.842270);
            const ne = new mapboxgl.LngLat(-112.117550, 41.116208);

            //const sw = new mapboxgl.LngLat(-112.273911, 40.842270);
            console.log("sw coords: ", sw);
            //const ne = new mapboxgl.LngLat(-112.109447, 41.108855);
            const llb = new mapboxgl.LngLatBounds(sw, ne);
            this.boundries = llb;

            const map = new mapboxgl.Map({
                container: "map",
                style: "mapbox://styles/mapbox/streets-v11",
                //center: [-112.208200, 40.952868],
                center: [-112.176423, 41.007225],
                zoom: 2,
                maxBounds: llb,
            });

            var geojson = {
                type: 'FeatureCollection',
                features: [{
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [-112.126131, 41.089151]
                    },
                    properties: {
                        title: 'Mapbox',
                        description: 'Causeway 1'
                    }
                },
                {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [-112.252265, 41.033254]
                    },
                    properties: {
                        title: 'Mapbox',
                        description: 'Buffalo Point'
                    }
                },
                {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [-112.223244, 41.073405]
                    },
                    properties: {
                        title: 'Mapbox',
                        description: 'Causeway 2'
                    }
                },
                {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [-112.169479, 40.929460]
                    },
                    properties: {
                        title: 'Mapbox',
                        description: 'Fielding Garr Ranch'
                    }
                },
                {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        //41.049181, -112.248445
                        coordinates: [-112.248445, 41.049181]
                    },
                    properties: {
                        title: 'Mapbox',
                        description: 'Bridger Bay Beach'
                    }
                }]  
            };

            //const FGRMarker = new mapboxgl.Marker().setLngLat([-112.25346104321704,41.04527386502289]).addTo(map);
            // const Cause1Marker = new mapboxgl.Marker()
            //     .setLngLat([-112.168929, 40.927682])
            //     //-112.16892981146142,40.927682453543326
            //     .addTo(map);

            // const BuffMarker = new mapboxgl.Marker()
            //     .setLngLat([-112.252265, 41.033254])
            //     .addTo(map);


            for (const feature of geojson.features){
                //var el = document.createElement('div');
                //el.className = 'marker';

                new mapboxgl.Marker({
                    color: "#D79A02"
                }).setLngLat(feature.geometry.coordinates).addTo(map);
            };

            

            const locations = new Array();
            locations.push({ coords:{latitude:41.056951,longitude:-112.237145},duration:5000 });
            locations.push({ coords:{latitude:41.031680,longitude:-112.204627},duration:5000 });

            

            map.on('load', function () {
                map.addSource('multiple-lines-source', {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': [
                            {
                                'type': 'Feature',
                                'properties': {},
                                'geometry': {
                                    'type': 'LineString',
                                    'coordinates': [
                                            [-112.117365,41.089287],
                                            [-112.13303,41.08928],
                                            [-112.18416,41.08931],
                                            [-112.18616,41.0892],
                                            [-112.18747,41.08904],
                                            [-112.188,41.08896],
                                            [-112.18974,41.08865],
                                            [-112.19028,41.08852],
                                            [-112.19076,41.08839],
                                            [-112.20058,41.08498],
                                            [-112.20079,41.0849],
                                            [-112.20426,41.0837],
                                            [-112.20427,41.0837],
                                            [-112.21289,41.08069],
                                            [-112.21408,41.08018],
                                            [-112.21484,41.07979],
                                            [-112.21522,41.07958],
                                            [-112.21586,41.0792],
                                            [-112.21633,41.07889],
                                            [-112.21761,41.07793],
                                            [-112.21864,41.07713],
                                            [-112.21883,41.07697],
                                            [-112.21993,41.07612],
                                            [-112.22007,41.07602],
                                            [-112.2201,41.07599],
                                            [-112.22027,41.07587],
                                            [-112.22209,41.07444],
                                            [-112.22219,41.07437],
                                            [-112.22306,41.0736],
                                            [-112.22628,41.07052],
                                            [-112.22633,41.07046],
                                            [-112.231,41.066],
                                            [-112.23712,41.06001],
                                            [-112.23722,41.0599],
                                            [-112.23731,41.05982],
                                            [-112.23737,41.05975],
                                            [-112.23743,41.05966],
                                            [-112.23748,41.05957],
                                            [-112.23754,41.05942],
                                            [-112.23756,41.05935],
                                            [-112.23758,41.05922],
                                            [-112.23758,41.05912],
                                            [-112.23756,41.05894],
                                            [-112.23754,41.05886],
                                            [-112.23751,41.05878],
                                            [-112.23751,41.05877],
                                            [-112.23746,41.05859],
                                            [-112.2374,41.05842],
                                            [-112.23712,41.05742],
                                            [-112.23711,41.05736],
                                            [-112.23708,41.05727],
                                            [-112.23707,41.05718],
                                            [-112.23704,41.05703],
                                            [-112.23704,41.05701],
                                            [-112.23688,41.05593],
                                            [-112.23675,41.05536],
                                            [-112.23666,41.05505],
                                            [-112.23664,41.05501],
                                            [-112.23654,41.0547],
                                            [-112.23653,41.05465],
                                            [-112.23638,41.05412],
                                            [-112.23629,41.05365],
                                            [-112.23629,41.05364],
                                            [-112.23622,41.05317],
                                            [-112.23621,41.053],
                                            [-112.23621,41.05274],
                                            [-112.23622,41.0527],
                                            [-112.23622,41.05259],
                                            [-112.23636,41.05131],
                                            [-112.23636,41.05127],
                                            [-112.23643,41.05059],
                                            [-112.23616,41.05053],
                                            [-112.23604,41.05051],
                                            [-112.23581,41.05041],
                                            [-112.23581,41.0504],
                                            [-112.23573,41.05035],
                                            [-112.23564,41.05025],
                                            [-112.23557,41.05015],
                                            [-112.23553,41.05007],
                                            [-112.23548,41.04993],
                                            [-112.23536,41.0497],
                                            [-112.23532,41.04961],
                                            [-112.23523,41.04944],
                                            [-112.23507,41.0491],
                                            [-112.23491,41.04879],
                                            [-112.23418,41.04705],
                                            [-112.23395,41.04655],
                                            [-112.23378,41.04625],
                                            [-112.23366,41.04606],
                                            [-112.23365,41.04605],
                                            [-112.23304,41.04508],
                                            [-112.23272,41.0446],
                                            [-112.23244,41.04426],
                                            [-112.23234,41.04417],
                                            [-112.23217,41.044],
                                            [-112.23202,41.04387],
                                            [-112.23197,41.04382],
                                            [-112.23169,41.04361],
                                            [-112.23079,41.04302],
                                            [-112.23075,41.043],
                                            [-112.22994,41.04248],
                                            [-112.2298,41.0424],
                                            [-112.22965,41.04233],
                                            [-112.22883,41.042],
                                            [-112.22849,41.04188],
                                            [-112.22799,41.04174],
                                            [-112.22716,41.04156],
                                            [-112.22703,41.04152],
                                            [-112.22696,41.04151],
                                            [-112.22634,41.04131],
                                            [-112.22579,41.04116],
                                            [-112.22386,41.04073],
                                            [-112.22363,41.04067],
                                            [-112.22248,41.04042],
                                            [-112.22226,41.04036],
                                            [-112.22204,41.04031],
                                            [-112.22203,41.04031],
                                            [-112.2218,41.04027],
                                            [-112.22164,41.04023],
                                            [-112.22133,41.04018],
                                            [-112.2211,41.04016],
                                            [-112.22105,41.04015],
                                            [-112.22079,41.04012],
                                            [-112.22062,41.04011],
                                            [-112.22039,41.04011],
                                            [-112.22028,41.0401],
                                            [-112.21964,41.04012],
                                            [-112.21911,41.04017],
                                            [-112.21876,41.04022],
                                            [-112.2183,41.04031],
                                            [-112.21827,41.04031],
                                            [-112.21782,41.04039],
                                            [-112.2178,41.04039],
                                            [-112.21756,41.04042],
                                            [-112.21707,41.04046],
                                            [-112.21609,41.04049],
                                            [-112.21569,41.04049],
                                            [-112.21566,41.0405],
                                            [-112.21542,41.0405],
                                            [-112.21517,41.04052],
                                            [-112.21477,41.04058],
                                            [-112.21449,41.04064],
                                            [-112.21445,41.04064],
                                            [-112.21425,41.04067],
                                            [-112.21399,41.04069],
                                            [-112.2137,41.04069],
                                            [-112.21316,41.04065],
                                            [-112.2112,41.04055],
                                            [-112.21116,41.04054],
                                            [-112.21081,41.04052],
                                            [-112.21069,41.0405],
                                            [-112.21067,41.0405],
                                            [-112.21055,41.04048],
                                            [-112.21046,41.04045],
                                            [-112.21044,41.04045],
                                            [-112.21018,41.04035],
                                            [-112.21,41.04024],
                                            [-112.20976,41.03999],
                                            [-112.20968,41.03989],
                                            [-112.20964,41.03983],
                                            [-112.2094,41.03952],
                                            [-112.20925,41.03937],
                                            [-112.20898,41.03916],
                                            [-112.20879,41.03898],
                                            [-112.20875,41.03893],
                                            [-112.20864,41.03883],
                                            [-112.20849,41.03867],
                                            [-112.20837,41.03856],
                                            [-112.20822,41.03844],
                                            [-112.20644,41.03713],
                                            [-112.2063,41.037],
                                            [-112.20617,41.03686],
                                            [-112.20587,41.0365],
                                            [-112.20575,41.03638],
                                            [-112.20556,41.03613],
                                            [-112.20554,41.03611],
                                            [-112.20545,41.03596],
                                            [-112.20537,41.0358],
                                            [-112.20531,41.03562],
                                            [-112.2053,41.03561],
                                            [-112.20525,41.03526],
                                            [-112.20525,41.03507],
                                            [-112.20526,41.03491],
                                            [-112.20526,41.03455],
                                            [-112.20525,41.03442],
                                            [-112.20525,41.03433],
                                            [-112.20524,41.03422],
                                            [-112.20523,41.03419],
                                            [-112.20522,41.0341],
                                            [-112.20515,41.03375],
                                            [-112.20512,41.03367],
                                            [-112.20509,41.03354],
                                            [-112.20506,41.03346],
                                            [-112.205,41.03334],
                                            [-112.20493,41.03322],
                                            [-112.20486,41.03308],
                                            [-112.20479,41.03298],
                                            [-112.20465,41.03268],
                                            [-112.20461,41.03257],
                                            [-112.20457,41.03236],
                                            [-112.20457,41.03221],
                                            [-112.2047,41.0311],
                                            [-112.2047,41.03103],
                                            [-112.20472,41.03088],
                                            [-112.20474,41.03034],
                                            [-112.20471,41.02996],
                                            [-112.20464,41.02974],
                                            [-112.20459,41.02961],
                                            [-112.2045,41.02943],
                                            [-112.20441,41.02929],
                                            [-112.20434,41.0292],
                                            [-112.20414,41.02899],
                                            [-112.20387,41.02878],
                                            [-112.20361,41.02861],
                                            [-112.20343,41.02847],
                                            [-112.20331,41.02839],
                                            [-112.20327,41.02835],
                                            [-112.20322,41.02831],
                                            [-112.20299,41.02807],
                                            [-112.20278,41.02777],
                                            [-112.20256,41.02741],
                                            [-112.20231,41.02706],
                                            [-112.20218,41.02692],
                                            [-112.20206,41.02681],
                                            [-112.20184,41.02664],
                                            [-112.20173,41.02657],
                                            [-112.20172,41.02657],
                                            [-112.20159,41.0265],
                                            [-112.20152,41.02645],
                                            [-112.20136,41.02638],
                                            [-112.20104,41.02628],
                                            [-112.20088,41.02624],
                                            [-112.20069,41.02621],
                                            [-112.19976,41.02611],
                                            [-112.19965,41.02609],
                                            [-112.1993,41.02599],
                                            [-112.19848,41.0257],
                                            [-112.19831,41.02562],
                                            [-112.19831,41.02561],
                                            [-112.19817,41.02555],
                                            [-112.19788,41.02537],
                                            [-112.19765,41.0252],
                                            [-112.19744,41.02506],
                                            [-112.19633,41.02425],
                                            [-112.19606,41.02404],
                                            [-112.19604,41.02403],
                                            [-112.19535,41.02354],
                                            [-112.19515,41.02341],
                                            [-112.19486,41.02327],
                                            [-112.1946,41.02317],
                                            [-112.19438,41.0231],
                                            [-112.19414,41.02304],
                                            [-112.19401,41.02302],
                                            [-112.1939,41.02301],
                                            [-112.19386,41.023],
                                            [-112.19382,41.023],
                                            [-112.19375,41.02299],
                                            [-112.19362,41.02298],
                                            [-112.19306,41.02298],
                                            [-112.19294,41.02299],
                                            [-112.19243,41.02295],
                                            [-112.1922,41.0229],
                                            [-112.19211,41.02287],
                                            [-112.19205,41.02286],
                                            [-112.19178,41.02276],
                                            [-112.19177,41.02275],
                                            [-112.19169,41.02272],
                                            [-112.19139,41.02255],
                                            [-112.19119,41.02239],
                                            [-112.19108,41.02229],
                                            [-112.1909,41.02209],
                                            [-112.19079,41.02191],
                                            [-112.19074,41.02181],
                                            [-112.19074,41.0218],
                                            [-112.1907,41.0217],
                                            [-112.19064,41.02145],
                                            [-112.19062,41.02119],
                                            [-112.19063,41.02109],
                                            [-112.19064,41.02106],
                                            [-112.19066,41.02095],
                                            [-112.19069,41.02085],
                                            [-112.19074,41.02074],
                                            [-112.19074,41.02073],
                                            [-112.19082,41.02057],
                                            [-112.19082,41.02056],
                                            [-112.19086,41.02051],
                                            [-112.19097,41.02035],
                                            [-112.19104,41.02026],
                                            [-112.19119,41.02011],
                                            [-112.1912,41.02009],
                                            [-112.19161,41.01967],
                                            [-112.19198,41.01927],
                                            [-112.19226,41.01899],
                                            [-112.19293,41.01828],
                                            [-112.19352,41.01761],
                                            [-112.19409,41.0169],
                                            [-112.19427,41.01669],
                                            [-112.19454,41.01631],
                                            [-112.19466,41.01611],
                                            [-112.19481,41.0157],
                                            [-112.19481,41.01569],
                                            [-112.19487,41.01534],
                                            [-112.19491,41.01498],
                                            [-112.19495,41.01471],
                                            [-112.19507,41.01428],
                                            [-112.19514,41.01407],
                                            [-112.19542,41.01333],
                                            [-112.19551,41.01306],
                                            [-112.19561,41.0127],
                                            [-112.19566,41.01248],
                                            [-112.19596,41.01056],
                                            [-112.19597,41.01052],
                                            [-112.19604,41.01001],
                                            [-112.19607,41.00985],
                                            [-112.19609,41.00969],
                                            [-112.19612,41.00952],
                                            [-112.19618,41.00908],
                                            [-112.19622,41.00891],
                                            [-112.19625,41.00872],
                                            [-112.19631,41.00847],
                                            [-112.19636,41.0083],
                                            [-112.19638,41.00825],
                                            [-112.19645,41.00801],
                                            [-112.19651,41.00787],
                                            [-112.19684,41.00718],
                                            [-112.19691,41.00706],
                                            [-112.19707,41.00672],
                                            [-112.19715,41.00648],
                                            [-112.19718,41.00628],
                                            [-112.19718,41.00616],
                                            [-112.19719,41.00607],
                                            [-112.19718,41.00601],
                                            [-112.19718,41.00591],
                                            [-112.19715,41.00565],
                                            [-112.19714,41.00547],
                                            [-112.19714,41.00526],
                                            [-112.19716,41.00512],
                                            [-112.19723,41.00484],
                                            [-112.19734,41.00448],
                                            [-112.19738,41.00431],
                                            [-112.19747,41.00384],
                                            [-112.19752,41.00329],
                                            [-112.19751,41.00279],
                                            [-112.19752,41.00273],
                                            [-112.19752,41.00265],
                                            [-112.1976,41.00234],
                                            [-112.19764,41.00223],
                                            [-112.19771,41.00207],
                                            [-112.19789,41.0016],
                                            [-112.19809,41.00103],
                                            [-112.19814,41.00091],
                                            [-112.19818,41.00078],
                                            [-112.19821,41.0007],
                                            [-112.19826,41.00053],
                                            [-112.19828,41.00044],
                                            [-112.19829,41.00034],
                                            [-112.19829,41.0002],
                                            [-112.19827,40.99994],
                                            [-112.19825,40.99983],
                                            [-112.19818,40.99959],
                                            [-112.19815,40.99946],
                                            [-112.19809,40.99929],
                                            [-112.198,40.99891],
                                            [-112.19799,40.99879],
                                            [-112.19799,40.99867],
                                            [-112.19808,40.99796],
                                            [-112.19816,40.99749],
                                            [-112.19825,40.99681],
                                            [-112.19825,40.99653],
                                            [-112.19822,40.99641],
                                            [-112.1982,40.9963],
                                            [-112.1981,40.99606],
                                            [-112.19799,40.99585],
                                            [-112.19793,40.99577],
                                            [-112.19791,40.99575],
                                            [-112.19779,40.9956],
                                            [-112.19766,40.99547],
                                            [-112.19725,40.99501],
                                            [-112.19706,40.99475],
                                            [-112.19703,40.9947],
                                            [-112.19698,40.99463],
                                            [-112.19672,40.99422],
                                            [-112.19671,40.99421],
                                            [-112.19653,40.99395],
                                            [-112.19641,40.99381],
                                            [-112.19633,40.99373],
                                            [-112.19628,40.99367],
                                            [-112.19602,40.99342],
                                            [-112.19537,40.99284],
                                            [-112.19531,40.99277],
                                            [-112.19529,40.99274],
                                            [-112.19512,40.99253],
                                            [-112.19468,40.99195],
                                            [-112.19448,40.99166],
                                            [-112.19436,40.99147],
                                            [-112.1943,40.99136],
                                            [-112.19417,40.99108],
                                            [-112.19399,40.99073],
                                            [-112.19386,40.99053],
                                            [-112.19372,40.99034],
                                            [-112.1933,40.98972],
                                            [-112.19311,40.98939],
                                            [-112.193,40.98916],
                                            [-112.19293,40.98899],
                                            [-112.19286,40.98885],
                                            [-112.19272,40.98849],
                                            [-112.19251,40.98802],
                                            [-112.19243,40.98787],
                                            [-112.19242,40.98786],
                                            [-112.19215,40.98736],
                                            [-112.19211,40.98727],
                                            [-112.19202,40.9871],
                                            [-112.19099,40.98494],
                                            [-112.19094,40.98482],
                                            [-112.1903,40.98347],
                                            [-112.1903,40.98346],
                                            [-112.19024,40.98335],
                                            [-112.19018,40.98322],
                                            [-112.19004,40.98297],
                                            [-112.19004,40.98296],
                                            [-112.18991,40.98277],
                                            [-112.18981,40.98265],
                                            [-112.18959,40.98244],
                                            [-112.18949,40.98236],
                                            [-112.18936,40.98224],
                                            [-112.18874,40.98171],
                                            [-112.18843,40.98141],
                                            [-112.18815,40.98112],
                                            [-112.18802,40.98097],
                                            [-112.18796,40.98089],
                                            [-112.18761,40.98051],
                                            [-112.18747,40.98038],
                                            [-112.18722,40.9802],
                                            [-112.18651,40.97976],
                                            [-112.18633,40.97963],
                                            [-112.18603,40.97939],
                                            [-112.18583,40.97921],
                                            [-112.18534,40.97873],
                                            [-112.18501,40.97837],
                                            [-112.18478,40.97807],
                                            [-112.18451,40.97769],
                                            [-112.18417,40.97714],
                                            [-112.18381,40.97651],
                                            [-112.18358,40.97601],
                                            [-112.18283,40.97412],
                                            [-112.18273,40.9739],
                                            [-112.18263,40.97374],
                                            [-112.18261,40.9737],
                                            [-112.18249,40.9735],
                                            [-112.18212,40.97303],
                                            [-112.18151,40.9723],
                                            [-112.18127,40.97203],
                                            [-112.18114,40.9719],
                                            [-112.18109,40.97186],
                                            [-112.18097,40.97178],
                                            [-112.18062,40.97157],
                                            [-112.18052,40.9715],
                                            [-112.18031,40.97133],
                                            [-112.18014,40.97117],
                                            [-112.17944,40.97041],
                                            [-112.17932,40.97029],
                                            [-112.17881,40.96972],
                                            [-112.17854,40.96933],
                                            [-112.17811,40.96867],
                                            [-112.17793,40.96833],
                                            [-112.1778,40.96806],
                                            [-112.17769,40.96779],
                                            [-112.17725,40.96646],
                                            [-112.1772,40.96625],
                                            [-112.17709,40.96563],
                                            [-112.17704,40.96522],
                                            [-112.17699,40.9649],
                                            [-112.17695,40.9647],
                                            [-112.17682,40.96429],
                                            [-112.17675,40.96416],
                                            [-112.17665,40.96394],
                                            [-112.17651,40.96367],
                                            [-112.17632,40.96338],
                                            [-112.1763,40.96336],
                                            [-112.17622,40.96323],
                                            [-112.17589,40.96278],
                                            [-112.17577,40.9626],
                                            [-112.17576,40.96257],
                                            [-112.17547,40.96209],
                                            [-112.17536,40.96188],
                                            [-112.17535,40.96187],
                                            [-112.17507,40.96126],
                                            [-112.17491,40.96086],
                                            [-112.17436,40.95936],
                                            [-112.17433,40.9593],
                                            [-112.17428,40.95917],
                                            [-112.17422,40.95905],
                                            [-112.17415,40.95893],
                                            [-112.17394,40.95865],
                                            [-112.17322,40.95793],
                                            [-112.17317,40.95787],
                                            [-112.17276,40.95746],
                                            [-112.17252,40.9572],
                                            [-112.17242,40.95707],
                                            [-112.17188,40.9562],
                                            [-112.17171,40.95589],
                                            [-112.17166,40.95571],
                                            [-112.17162,40.95552],
                                            [-112.1716,40.95537],
                                            [-112.17146,40.95374],
                                            [-112.17145,40.95351],
                                            [-112.17145,40.95331],
                                            [-112.17166,40.95193],
                                            [-112.17169,40.9516],
                                            [-112.17169,40.95151],
                                            [-112.17167,40.95124],
                                            [-112.17167,40.95099],
                                            [-112.17169,40.95079],
                                            [-112.17199,40.94965],
                                            [-112.17204,40.94943],
                                            [-112.17214,40.94884],
                                            [-112.17271,40.94448],
                                            [-112.17277,40.94412],
                                            [-112.1728,40.944],
                                            [-112.17313,40.94307],
                                            [-112.17313,40.94306],
                                            [-112.17319,40.94284],
                                            [-112.1732,40.94273],
                                            [-112.17321,40.94232],
                                            [-112.1732,40.94217],
                                            [-112.17319,40.94119],
                                            [-112.1732,40.94096],
                                            [-112.17333,40.94001],
                                            [-112.17334,40.9399],
                                            [-112.17359,40.93822],
                                            [-112.17359,40.93821],
                                            [-112.17364,40.9379],
                                            [-112.17366,40.93771],
                                            [-112.17368,40.93759],
                                            [-112.17368,40.93726],
                                            [-112.17366,40.93718],
                                            [-112.17366,40.93715],
                                            [-112.17364,40.93706],
                                            [-112.17353,40.93676],
                                            [-112.17341,40.93654],
                                            [-112.17148,40.93343],
                                            [-112.17148,40.93342],
                                            [-112.17044,40.93177],
                                            [-112.17035,40.93164],
                                            [-112.1702,40.9314],
                                            [-112.17013,40.93127],
                                            [-112.17002,40.93102],
                                            [-112.17001,40.93097],
                                            [-112.16955,40.92976],
                                            [-112.16915,40.92891],
                                            [-112.16907,40.92871],
                                            [-112.16897,40.92839],
                                            [-112.16894,40.92824],
                                            [-112.16894,40.92821],
                                            [-112.16891,40.9281],
                                            [-112.16889,40.92793],
                                            [-112.16889,40.92755],
                                            [-112.16892,40.92728],
                                            [-112.16897,40.92695],
                                            [-112.16932,40.92536],
                                            [-112.16934,40.92524],
                                    ]
                                }
                            },
                            {
                                'type': 'Feature',
                                'properties': {},
                                'geometry': {
                                    'type': 'LineString',
                                    'coordinates': [
                                        [-112.23637,41.05058],
                                        [-112.23643,41.05059],
                                        [-112.23647,41.05005],
                                        [-112.23649,41.04987],
                                        [-112.2365,41.04969],
                                        [-112.23651,41.04964],
                                        [-112.23661,41.0488],
                                        [-112.23663,41.04862],
                                        [-112.23665,41.04844],
                                        [-112.2367,41.0479],
                                        [-112.23673,41.04772],
                                        [-112.23674,41.04768],
                                        [-112.23679,41.04755],
                                        [-112.23681,41.04749],
                                        [-112.2369,41.04739],
                                        [-112.23694,41.04733],
                                        [-112.23704,41.04725],
                                        [-112.23716,41.04714],
                                        [-112.23739,41.047],
                                        [-112.23774,41.04675],
                                        [-112.23805,41.04651],
                                        [-112.23823,41.04636],
                                        [-112.23835,41.04626],
                                        [-112.23852,41.04608],
                                        [-112.23869,41.04591],
                                        [-112.23888,41.0457],
                                        [-112.23905,41.04548],
                                        [-112.23917,41.04532],
                                        [-112.23918,41.0453],
                                        [-112.23939,41.045],
                                        [-112.23954,41.04483],
                                        [-112.23967,41.04461],
                                        [-112.24004,41.04404],
                                        [-112.24015,41.04388],
                                        [-112.24018,41.04383],
                                        [-112.24059,41.04315],
                                        [-112.24064,41.04306],
                                        [-112.24073,41.0429],
                                        [-112.2409,41.0426],
                                        [-112.24108,41.0422],
                                        [-112.24121,41.04169],
                                        [-112.24127,41.04142],
                                        [-112.2417,41.0415],
                                        [-112.24259,41.04167],
                                        [-112.24287,41.04171],
                                        [-112.2431,41.04174],
                                        [-112.244,41.04187],
                                        [-112.24514,41.04201],
                                        [-112.24521,41.04201],
                                        [-112.24545,41.04204],
                                        [-112.24565,41.04207],
                                        [-112.24625,41.04213],
                                        [-112.24663,41.04216],
                                        [-112.24683,41.04217],
                                        [-112.24687,41.04217],
                                        [-112.24735,41.04216],
                                        [-112.24749,41.04216],
                                        [-112.24759,41.04216],
                                        [-112.24795,41.04214],
                                        [-112.2484,41.04209],
                                        [-112.24945,41.04192],
                                        [-112.24994,41.04187],
                                        [-112.25039,41.04229],
                                        [-112.25071,41.04256],
                                        [-112.25083,41.04267],
                                        [-112.25153,41.04332],
                                        [-112.2524,41.04412],
                                        [-112.2526,41.04429],
                                        [-112.25304,41.04465],
                                        [-112.25324,41.04485],
                                        [-112.25327,41.04499],
                                        [-112.25324,41.0451],
                                        [-112.25323,41.04511],
                                        [-112.25316,41.04516],
                                        [-112.25291,41.04534],
                                        [-112.2529,41.04535],
                                        [-112.25281,41.04541],
                                        [-112.25247,41.04563],
                                        [-112.2521,41.04591],
                                        [-112.25197,41.04604],
                                        [-112.25189,41.04611],
                                        [-112.25167,41.0463],
                                        [-112.2515,41.04648],
                                        [-112.25138,41.0466],
                                        [-112.25125,41.04674],
                                        [-112.25115,41.04682],
                                        [-112.25099,41.04694],
                                        [-112.25091,41.04698],
                                        [-112.25085,41.04701],
                                        [-112.25055,41.04712],
                                        [-112.25039,41.04722],
                                        [-112.25038,41.04722],
                                        [-112.25033,41.0473],
                                        [-112.2503,41.04735],
                                        [-112.25014,41.04772],
                                        [-112.25011,41.0478],
                                        [-112.24994,41.04805],
                                        [-112.24986,41.04812],
                                        [-112.24978,41.0482],
                                        [-112.24972,41.04826],
                                        [-112.24912,41.04872],
                                        [-112.24877,41.04896],
                                        [-112.24869,41.04902],
                                        [-112.2486,41.04908],
                                        [-112.24856,41.04911],
                                        [-112.24836,41.04927],
                                        [-112.24833,41.04929],
                                        [-112.24797,41.0497],
                                        [-112.24781,41.04989],
                                        [-112.2476,41.05015],
                                        [-112.24755,41.05025],
                                        [-112.24754,41.05027],
                                        [-112.24751,41.05063],
                                        [-112.2475,41.05079],
                                        [-112.2475,41.05081],
                                        [-112.24745,41.05091],
                                        [-112.24733,41.05099],
                                        [-112.24719,41.05103]
                                    ]
                                }
                            },
                            {
                                'type': 'Feature',
                                'properties': {},
                                'geometry': {
                                    'type': 'LineString',
                                    'coordinates': [
                                        [-112.2414,41.04145],
                                        [-112.24127,41.04142],
                                        [-112.2415,41.04037],
                                        [-112.24154,41.04018],
                                        [-112.24165,41.03973],
                                        [-112.24178,41.03931],
                                        [-112.24178,41.0393],
                                        [-112.24187,41.03911],
                                        [-112.24201,41.03882],
                                        [-112.24223,41.03847],
                                        [-112.24235,41.03829],
                                        [-112.24245,41.03812],
                                        [-112.24276,41.03766],
                                        [-112.24337,41.03676],
                                        [-112.24365,41.03647],
                                        [-112.24395,41.0362],
                                        [-112.24419,41.03598],
                                        [-112.24442,41.03582],
                                        [-112.24445,41.0358],
                                        [-112.24456,41.03573],
                                        [-112.24477,41.03565],
                                        [-112.24502,41.03557],
                                        [-112.24523,41.03551],
                                        [-112.24555,41.03547],
                                        [-112.24572,41.03544],
                                        [-112.24578,41.03543],
                                        [-112.24604,41.03539],
                                        [-112.24635,41.03531],
                                        [-112.24666,41.03521],
                                        [-112.24696,41.03511],
                                        [-112.24712,41.03507],
                                        [-112.24717,41.03506],
                                        [-112.24737,41.03504],
                                        [-112.24784,41.03504],
                                        [-112.24808,41.03504],
                                        [-112.24879,41.03501],
                                        [-112.24882,41.03501],
                                        [-112.24917,41.03499],
                                        [-112.24974,41.03494],
                                        [-112.24983,41.03493],
                                        [-112.25021,41.03489],
                                        [-112.25058,41.03486],
                                        [-112.25096,41.03485],
                                        [-112.25116,41.03485],
                                        [-112.25126,41.03485],
                                        [-112.25142,41.0348],
                                        [-112.25151,41.03475],
                                        [-112.25157,41.0347],
                                        [-112.25159,41.03468],
                                        [-112.25162,41.03458],
                                        [-112.25163,41.03453],
                                        [-112.25171,41.034],
                                        [-112.25178,41.03372],
                                        [-112.25182,41.03364],
                                        [-112.25184,41.03361],
                                        [-112.25192,41.0335],
                                        [-112.25194,41.03348],
                                        [-112.25201,41.03341],
                                        [-112.25217,41.0333],
                                        [-112.25229,41.03325],
                                        [-112.25231,41.03324],
                                        [-112.25252,41.03318],
                                        [-112.25275,41.03318],
                                        [-112.25323,41.03318],
                                        [-112.25336,41.03318],
                                        [-112.2537,41.03316],
                                        [-112.25408,41.03314],
                                        [-112.25418,41.03312],
                                        [-112.25429,41.03311],
                                        [-112.25448,41.03305],
                                        [-112.25497,41.03292],
                                        [-112.25508,41.03289],
                                        [-112.25532,41.03284],
                                        [-112.2561,41.03274],
                                        [-112.25625,41.03273]
                                    ]
                                }
                            }
                        ]
                    },
                });

                map.addLayer({
                    'id': 'multiple-lines-layer',
                    'type': 'line',
                    'source': 'multiple-lines-source',
                    'layout': {
                    },
                    'paint': {
                        'line-color': '#E3BC0F',
                        'line-width': 6
                    }
                });
            });

            map.on('load', function () {
                // Request Geolocation Permission Again
                navigator.permissions.query({name:'geolocation'}).then(function(permissionStatus) {
                    console.log('geolocation permission state is ', permissionStatus.state);

                    if(permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
                        var options = {
                            enableHighAccuracy: true,
                            timeout: 15000,
                            maximumAge: 0
                        };

                        // Use options as the third argument for getCurrentPosition
                        navigator.geolocation.getCurrentPosition(function (position) {
                            const userCoordinates = [position.coords.longitude, position.coords.latitude];

                            map.addSource('user-coordinates', {
                                'type': 'geojson',
                                'data': {
                                    'type': 'Feature',
                                    'geometry': {
                                        'type': 'Point',
                                        'coordinates': userCoordinates
                                    }
                                }
                            });

                            map.addLayer({
                                'id': 'user-coordinates',
                                'type': 'circle',
                                'source': 'user-coordinates',
                            });

                            // Use options as the third argument for watchPosition
                            navigator.geolocation.watchPosition(function (position) {
                                const userCoordinates = [position.coords.longitude, position.coords.latitude];

                                if (map.isSourceLoaded('user-coordinates')) {
                                    map.getSource('user-coordinates').setData({
                                        'type': 'Feature',
                                        'geometry': {
                                            'type': 'Point',
                                            'coordinates': userCoordinates
                                        }
                                    });
                                }

                                // Rest of your code...
                            }, function(error) {
                                console.error("Error Code = " + error.code + " - " + error.message);
                            }, options);
                        }, function(error) {
                            console.error("Error Code = " + error.code + " - " + error.message);
                        }, options);
                    }
                });
            });

        },
        methods: {
            
        }

        
    };



    
</script>

<style lang="scss" scoped>
.basemap {
    width: 100%;
    height: 100%;
}
.marker{
    background-size: cover;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
}
g{
    fill: #D79A02;
}
.mapboxgl-ctrl-bottom-left{
    display: none;
}
.mapboxgl-ctrl-bottom-right{
    display: none;
}
.mapboxgl-ctrl-logo {
    display: none !important;
}

</style>